import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantReviewPage = {
  footer: {
    root: 'applicant-review-page.footer.root',
  },
  form: {
    h1: 'applicant-review-page.form.h1',
    h2: 'applicant-review-page.form.h2',
    root: 'applicant-review-page.form.root',
    submitButton: 'applicant-review-page.form.submit-button',
  },
  header: {
    drawerButton: 'applicant-review-page.header.drawer-button',
    previousStepButton: 'applicant-review-page.header.previous-step-button',
    root: 'applicant-review-page.header.root',
  },
  progress: {
    root: 'applicant-review-page.progress.root',
  },
} as const satisfies PageLocatorMap;
